import { Inject, Injectable } from '@angular/core';
import { BASE_URI_CONFIG, BaseUriConfig } from '@smooved/ui';
import { WaterTransferAssetType } from '@ui/water/enums/water-transfer-asset-type.enum';
import { Observable } from 'rxjs';
import { ArrayUtils, HttpUtils } from '@smooved/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { WaterInfoResponse } from '@ui/water/interfaces/water-info-response';
import { map } from 'rxjs/operators';
import { WaterSupplier } from '@ui/water/interfaces/water-supplier';

@Injectable()
export class UiWaterService {
    constructor(
        @Inject(BASE_URI_CONFIG) private readonly baseUriConfig: BaseUriConfig,
        private readonly httpClient: HttpClient
    ) {}

    public getWaterInfoByZipCode(zipCode: string): Observable<WaterInfoResponse[]> {
        const httpParams: HttpParams = new HttpParams().set('zipCode', zipCode);
        return this.httpClient
            .get<WaterInfoResponse[]>(`${this.baseUriConfig.apiUri}/water`, {
                params: httpParams,
            })
            .pipe(
                map((x) => {
                    return x.sort((a, b) => {
                        const valueForA = a.subMunicipality || a.municipality;
                        const valueForB = b.subMunicipality || b.municipality;
                        if (valueForA < valueForB) {
                            return -1;
                        }
                        if (valueForA > valueForB) {
                            return 1;
                        }
                        return 0;
                    });
                })
            );
    }
}
